module.exports = __webpack_public_path__ + "img/1581848416.7aa98b81.jpg";